module.exports = __webpack_public_path__ + "img/img-nocontent.ac4919d8.svg";